import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { ModalController } from '@ionic/angular';
import { CariHesapEkstresiFilter } from '@models/finance';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cari-hesap-ekstresi-filter',
  templateUrl: './cari-hesap-ekstresi-filter.component.html',
  styleUrls: ['./cari-hesap-ekstresi-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CariHesapEkstresiFilterComponent implements OnInit {
  @Input() cariHesapEkstersiFilter: CariHesapEkstresiFilter;
  
  constructor(
    public app: AppService,
    public modalController: ModalController,
  ) {
    this.cariHesapEkstersiFilter = new CariHesapEkstresiFilter();
   }

  ngOnInit(): void {
  }

  selectedFilter() {
    if (this.cariHesapEkstersiFilter.baslangicTarihi === undefined || this.cariHesapEkstersiFilter.bitisTarihi === undefined) {
      Swal.fire({
        title: 'Bilgi!',
        text: `Tarih aralığı boş bırakılamaz.`,
        icon: 'info',
        confirmButtonText: 'Tamam',
        allowOutsideClick: false,
        heightAuto: false
      });
    } else {
      this.modalController.dismiss({
        dismissed: true,
        baslangicTarihi: this.cariHesapEkstersiFilter.baslangicTarihi,
        bitisTarihi: this.cariHesapEkstersiFilter.bitisTarihi
      });
    }
  }

  async dismiss(dismissed: boolean) {
    await this.modalController.dismiss(dismissed);
  }
}
